import { ActionTree } from "vuex";
import { AppState } from "./index";
import { RootState } from "../index";

export const actions: ActionTree<AppState, RootState> = {};
